export type ActionButtonType = 'x' | 'z';

interface IProps {
    button: ActionButtonType,
    onDown?(): void;
    onUp?(): void;
}

export const ActionButton: React.FC<IProps> = ({ button, onDown, onUp }) => {

    const smallScreenSize = window.innerWidth < 500

    return (
        <button
            className={`h-13 w-13 bg-black flex justify-center items-center select-none ${button === 'x' ? "top-0" : "top-54"} ${button === 'x' ? "mr-0" : "mr-13"} ${button === 'x' ? "ml-13" : "ml-0"} pixel-corners shading shading-active`}
            onMouseDown={smallScreenSize ? undefined : onDown}
            onMouseUp={smallScreenSize ? undefined : onUp}
            onTouchStart={smallScreenSize ? onDown : undefined}
            onTouchEnd={smallScreenSize ? onUp : undefined}
        >
            <p className='btn-text self-center'>{button.toUpperCase()}</p>
        </button>
    )
}